/**
 * Pure-data English catalogue for namespace 'ops' (W1-03 core-model-ops). Imports only core/util/types.
 * Reasons produced by the transaction builder (core/doc/txDraft.ts).
 */

import type { MessageCatalog } from '../util/types';

const catalog: MessageCatalog = {
  ns: 'ops',
  locale: 'en',
  messages: {
    stale: 'The change could not be applied because the project changed in the meantime. Try again.',
  },
};

export default catalog;
